import { set } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import { DateObject } from 'react-multi-date-picker';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';

type Props = {
  timezone: string | null;
  date: DateObject;
  baseDate?: Date;
  time?: string;
};

export const DAY_START = 'start';
export const DAY_END = 'end';

type TimeValues = Partial<{
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
}>;

const DAY_START_TIME: TimeValues = { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
const DAY_END_TIME: TimeValues = { hours: 23, minutes: 59, seconds: 59, milliseconds: 999 };

const getTimeValues = (time?: string): TimeValues => {
  if (time === DAY_START) {
    return DAY_START_TIME;
  }
  if (time === DAY_END) {
    return DAY_END_TIME;
  }
  if (!time) {
    return {};
  }
  const [hours, minutes] = time.split(':').map(Number);

  return {
    hours,
    minutes,
  };
};

export function setZonedDate({ timezone, date, baseDate, time }: Props): Date {
  const tz = timezone || DEFAULT_TIMEZONE;
  const zoned = set(toZonedTime(baseDate ?? new Date(), tz), {
    year: date.year,
    month: date.monthIndex,
    date: date.day,
    ...getTimeValues(time),
    seconds: 0,
    milliseconds: 0,
  });

  return fromZonedTime(zoned, tz);
}
